import { render } from "./BoardSelectorPopup.vue?vue&type=template&id=a4799ab2&ts=true"
import script from "./BoardSelectorPopup.vue?vue&type=script&lang=ts"
export * from "./BoardSelectorPopup.vue?vue&type=script&lang=ts"

import "./BoardSelectorPopup.vue?vue&type=style&index=0&id=a4799ab2&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__